import { CheckoutSegmentCategory } from "@redotech/redo-model/conversion/checkout-segments/checkout-segment-category";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

/**
 * Schema for getting segmented checkout metrics for an A/B test split
 */
const segmentTreatmentMetricsSchema = z.object({
  treatmentId: z.string(),
  treatmentName: z.string(),
  isControl: z.boolean(),
  checkoutVisits: z.number(),
  checkoutCompletions: z.number(),
  conversionRate: z.number(),
  aov: z.number(),
  revenuePerCheckoutVisit: z.number(),
  confidence: z.number(),
});

export type SegmentTreatmentMetrics = z.infer<
  typeof segmentTreatmentMetricsSchema
>;

export const getSegmentedCheckoutMetricsForSplit = {
  name: "getSegmentedCheckoutMetricsForSplit" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({
    segments: z.array(
      z.object({
        segmentKey: z.string(),
        name: z.string(),
        category: createEnum(CheckoutSegmentCategory),
        totalCheckoutVisits: z.number(),
        totalCheckoutCompletions: z.number(),
        conversionRate: z.number(),
        aov: z.number(),
        revenuePerCheckoutVisit: z.number(),
        treatments: z.array(segmentTreatmentMetricsSchema),
      }),
    ),
  }),
};
export type GetSegmentedCheckoutMetricsForSplitOutput = z.infer<
  typeof getSegmentedCheckoutMetricsForSplit.output
>;
